import { FC } from 'react';
import cm from 'classnames';

import { Modal } from 'components/UI/modal/modal';
import { Button } from 'components/UI/button/button';
import { InputGroup } from 'components/UI/input/input-group';
import { InputBase } from 'components/UI/input/elements/input-base';
import styles from './_elements.module.scss';

type Props = {
  modalTitle: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  inputValue: string;
  onInputChange: (value: string) => void;
  disabled: boolean;
  externalClass?: string;
  submitText?: string;
};

export const CreateElementModal: FC<Props> = ({
  modalTitle,
  isOpen,
  disabled,
  onInputChange,
  inputValue,
  onClose,
  onSubmit,
  submitText,
}) => {
  return (
    <Modal className={cm(styles.AddModal)} onRequestClose={onClose} isOpen={isOpen}>
      <h3>{modalTitle}</h3>
      <InputGroup>
        <InputBase
          data-testid="modal-input"
          onChange={(e) => onInputChange(e.target.value)}
          value={inputValue}
          autoFocus
        />
      </InputGroup>

      <div className={styles.AddModal__footer}>
        <Button outlined onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onSubmit} disabled={disabled}>
          {submitText ?? 'Create'}
        </Button>
      </div>
    </Modal>
  );
};
